import { createModuleTipRules } from '../../application/composer/modulePromptRegistry.js';
import { UI_DEFAULTS } from '../locale/labels';

export const CHAT_CONTENT_MAX_WIDTH = 980;

export const RESOLVED_UI_LABELS = {
  tab_chats: '会话',
  tab_sources: '资料',
  edit_project_button: '编辑',
  sidebar_operations_title: '常规操作',
  project_select_hint: '请从左侧项目列表选择一个项目。',
  project_create_hint: '先创建一个项目，然后开始会话。',
  project_list_empty: '还没有项目，点击“创建项目”开始。',
  new_project_button: '创建项目',
  empty_state_title: UI_DEFAULTS.emptyStateTitle,
  empty_state_description: UI_DEFAULTS.emptyStateDescription,
  customer_role_fallback: UI_DEFAULTS.customerRoleFallback,
  scenario_panel_title: '起步入口',
  scenario_expand_label: '查看更多',
  scenario_collapse_label: '收起',
  composer_attach_label: '上传文件',
  composer_hint: '描述你的目标、背景或约束，系统会先帮你判断下一步。',
  canvas_workspace_title: '梳理模式工作区',
  canvas_tab_result: '需求梳理',
  canvas_tab_artifact: '工作文档',
  canvas_tab_analysis: '分析报告',
  canvas_tab_sourcing: '寻源结果',
  canvas_tab_evidence: '检索证据',
  sources_add_button: '添加资料',
  sources_loading: '资料加载中...',
  sources_empty_description: '上传到当前会话资料区后，本会话可以复用这些资料。',
};

export const MODE_SUGGESTION_TIP_RULES = createModuleTipRules();
